import { render, staticRenderFns } from "./xijiang.vue?vue&type=template&id=b4fc6c44&scoped=true&"
import script from "./xijiang.vue?vue&type=script&lang=js&"
export * from "./xijiang.vue?vue&type=script&lang=js&"
import style0 from "./xijiang.vue?vue&type=style&index=0&id=b4fc6c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fc6c44",
  null
  
)

export default component.exports